export default function LogsPage() {
  return <div><h2>Журнал действий</h2><p>Здесь будет просмотр лога действий (только для администратора).</p></div>;
} 